import axios from '../plugins/axios.js';


const _apiClient = {
    /**
     * @typedef {Object} User
     * @property {string} userId
     * @property {string} fullName
     * @property {string} nickName
     * @property {string} fullAvatarUrl - the avatar url of the user, if the user does not set his/her avatar, this field will be null
     * @property {string} userType - T - teacher, S - student, others mean not a user neither a student
     * @property {string} studentNo - for teacher user, this is the badge number; for student user, this is the student number
     * 
     */

    /**
     * @typedef {Object} LoginResponse
     * @property {boolean} status
     * @property {User} user
     */

    /**
     * Do login with account name (phone number) and password
     * @param {string} phoneNumber the phone number
     * @param {string} password the password
     * @returns {Promise<import('axios').AxiosResponse<LoginResponse>>}
     * @see <a href="https://p.mbook.cc/w/coreapi/user/login/">001.008 - 用户使用账号密码/手机号/Token登陆</a>
     */
    doPasswordLogin: function(phoneNumber, password) {
        return axios.request({
            method: 'POST',
            url: '/passports/account-login',
            data: {
                account: phoneNumber,
                password: password
            }
        });
    },

    /**
     * 短信验证码登录
     * @param {string} phoneNumber
     * @param {string} smsCode
     */
    doSmsCodeLogin: function(phoneNumber, smsCode) {
        return axios.request({
            method: 'POST',
            url: '/passports/phone-login',
            data: {
                phoneNumber: phoneNumber,
                smsCode: smsCode
            }
        });
    },

    /**
     * Gets the sm s code.
     * https://p.mbook.cc/w/coreapi/user/001.003-get-sms-code/
     * @param      {string}  type         The type
     * @param      {string}  phoneNumber  The phone number
     */
    getSmsCode: function(type, phoneNumber) {
        return axios.request({
            method: 'POST',
            url: '/sms-codes',
            data: {
                type: type,
                phoneNumber: phoneNumber,
                codeLen: 4
            }
        });
    },

    /**
     * Gets the login sms code.
     *
     * @param      {string}  phoneNumber  The phone number
     */
    getLoginSmsCode: function(phoneNumber) {
        return this.getSmsCode('LGN', phoneNumber);
    },


    /**
     * 获取注册验证码
     *
     * @param      {string}  phoneNumber  The phone number
     * @return     {Promise}
     */
    getRegisterSmsCode: function(phoneNumber) {
        return this.getSmsCode('RGS', phoneNumber);
    },
};

export default _apiClient;